import { render, staticRenderFns } from "./ResultPlugins.vue?vue&type=template&id=2f77b886&scoped=true&"
import script from "./ResultPlugins.vue?vue&type=script&lang=js&"
export * from "./ResultPlugins.vue?vue&type=script&lang=js&"
import style0 from "./ResultPlugins.vue?vue&type=style&index=0&id=2f77b886&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f77b886",
  null
  
)

export default component.exports